import { SyntheticEvent, useState } from 'react'
import downloadFunction from '../crudFunctions/downloadFunction'

interface props {
  setShowFileModal: React.Dispatch<React.SetStateAction<boolean>>
}

const GenerateFileModal = ({ setShowFileModal }: props) => {
  const [dateQuery, setDateQuery] = useState<string>('')
  const [isError, setIsError] = useState<string>('')

  const handleSubmit = (e: SyntheticEvent): void => {
    e.preventDefault()
    if (!dateQuery) {
      setIsError('Ingresa una fecha')
    } else {
      const endpoint: string = `payment/listall/${dateQuery}`
      downloadFunction(endpoint).then((response: any) => {
        if (response) {
          const url = window.URL.createObjectURL(response)
          const a = document.createElement('a')
          a.href = url
          a.download = 'ViperPaypagos.csv'
          document.body.appendChild(a)
          a.click()
          a.remove()
          setShowFileModal(false)
        } else {
          setIsError('No existen pagos a partir de esa fecha')
        }
      })
    }
  }
  return (
    <>
      <div id='generateFileModal' className='modal'>
        <div className='modal-content grid justify-items-center rounded-md'>
          <form className='grid' onSubmit={handleSubmit}>
            <label htmlFor='dateQuery' className='text-lg'>
              Listar pagos a partir de:
            </label>
            <input
              type='date'
              name='dateQuery'
              id='dateQuery'
              className='border-2 border-black rounded-md text-center'
              onChange={(e) => setDateQuery(e.target.value)}
            />

            {isError && (
              <p className='text-center text-red-400 mt-3'>{isError}</p>
            )}

            <button
              type='submit'
              className='bg-viper  text-white text-xl rounded-lg w-3/4 place-self-center px-8 py-2 mt-10 shadow-lg'>
              <span>Generar Archivo</span>
            </button>
          </form>
          <button
            className='bg-red-400  text-white text-xl rounded-lg px-8 py-2 mt-20 shadow-lg'
            onClick={() => setShowFileModal(false)}>
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default GenerateFileModal
